import { render } from "./login_main.vue?vue&type=template&id=622e727c&scoped=true"
import script from "./login_main.vue?vue&type=script&lang=js"
export * from "./login_main.vue?vue&type=script&lang=js"

import "./login_main.vue?vue&type=style&index=0&id=622e727c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622e727c"]])

export default __exports__